<template>
  <div class="ww dwp dbt" style="margin-top: 30px;">
    <div
      style="width:100%; background-color:white;border-radius:8px; margin-bottom:20px; overflow:hidden;padding:40px; "
    >
    <div class="dbt">
      <div class="dvend" style="font-size:25px;margin-left:-15px;">
        <div style="font-size:30px;color:red">【{{ "公司求购" }}】</div>
        {{ purchaseItem.title }}
      </div>
      <div>
          <el-link @click="$emit('back')" :underline="false" type="primary"> &lt;&lt; 返回</el-link>
      </div>
    </div>

      <div style="margin-top:10px;color: #999;">
        发布时间: {{ purchaseItem.created_at }}
      </div>
      <div
        class="dbt"
        style="margin-top:15px; padding:20px; border-bottom:1px solid rgb(230 228 228); border-top:1px solid rgb(230 228 228);"
      >
        <div class="dcy">
          <!-- <div style="color: #999;">求购地址</div> -->
          <div style="font-size:20px;color: red; margin-top:0px;">
            {{ purchaseItem.province_name }}-{{ purchaseItem.city_name }}-{{
              purchaseItem.region_name
            }}
          </div>
        </div>
        <div class="dcy">
          <!-- <div style="color: #999;">公司行业</div> -->
          <div style="font-size:20px;color: red; margin-top:0px;">
            {{ purchaseItem.category_name }}
          </div>
        </div>
        <!-- <div class="dcy">
              <div style="color: #999;">成立年限</div>
              <div>{{}}</div>
          </div> -->
      </div>
      <div class="dbty">
        <div style="margin-top: 30px;">
          意向价格:
          <div
            style="display:inline-block; font-size:30px;font-weight:700;color:red;"
          >
            {{ purchaseItem.price }} 元
          </div>
        </div>
        <div style="margin-top: 40px;">
            联系电话: {{purchaseItem.contact_phone}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Details",
  props: {
    purchaseItem: Object,
  },
  created() {
    this.$nextTick(() => {
      console.log("ssss", this.purchaseItem);
    });
  },

};
</script>
